import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';

export default class Spinner extends Component {
  static propTypes = {
    size: PropTypes.number,
    strokeWidth: PropTypes.number,
    strokeMiterlimit: PropTypes.number,
    inline: PropTypes.bool
  };

  static defaultProps = {
    size: 24,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    inline: false
  };

  render() {
    let size = this.props.size,
      strokeWidth = this.props.strokeWidth,
      strokeMiterlimit = this.props.strokeMiterlimit,
      radius = size - strokeWidth,
      classes;
    classes = ClassNames('spinner', {
      inline: this.props.inline
    });

    return (
      <div className={classes}>
        <svg className="circular" style={{ width: size * 2, height: size * 2 }}>
          <circle
            className="path"
            cx={size}
            cy={size}
            r={radius}
            fill="none"
            strokeWidth={strokeWidth}
            strokeMiterlimit={strokeMiterlimit}
          />
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/Spinner.js